import { AppContext } from "@/App.context";
import config from "@/config";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { DownloadFile } from "@/lib/download-file";

export const getReportLibraryDownload = (token) => {
  return async ({ service, download_id }, signal) => {
    const url = new URL(
      `${config.reportApiHost}/v1/${service}/reporting/report-download/${download_id}`
    );

    const owners = await fetch(url.toString(), {
      method: "GET",
      signal,
      headers: {
        Authorization: token,
      },
    });

    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }

    const reader = owners.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        function push() {
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);
            push();
          });
        }
        push();
      },
    });
    const blob = await new Response(stream).blob();
    const fileName = `Reporting library.csv`;
    DownloadFile(blob, fileName);
  };
};

/**

 * @param {GetStatisticsReq} req
 * @param {any[]=} deps
 */
export const UseReportLibraryDownload = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const mutation = useMutation({
    mutationKey: ["getReportLibraryDownload", req, ...deps],
    mutationFn: ({ signal }) =>
      getReportLibraryDownload(appContext.idToken)(req, signal),
  });
  return mutation;
};
